export default __webpack_public_path__ + "static/media/mallory_compact_medium_italic.ff05bb2e.ttf";